import { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { DayOfWeek } from '../../../../models/common';

interface IProps {
  dayOfWeek: DayOfWeek;
  setDayOfWeek: (newVal: DayOfWeek) => void;
}

const WeekDaySelect: FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { dayOfWeek, setDayOfWeek } = props;

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      <InputLabel>{t('f-com-notif-day')}</InputLabel>
      <Select
        label={t('f-com-notif-day')}
        value={dayOfWeek}
        onChange={(e) => {
          setDayOfWeek(e.target.value as DayOfWeek);
        }}
      >
        <MenuItem value={DayOfWeek.Monday}>{t('f-com-monday')}</MenuItem>
        <MenuItem value={DayOfWeek.Tuesday}>{t('f-com-tuesday')}</MenuItem>
        <MenuItem value={DayOfWeek.Wednesday}>{t('f-com-wednesday')}</MenuItem>
        <MenuItem value={DayOfWeek.Thursday}>{t('f-com-thursday')}</MenuItem>
        <MenuItem value={DayOfWeek.Friday}>{t('f-com-friday')}</MenuItem>
        <MenuItem value={DayOfWeek.Saturday}>{t('f-com-saturday')}</MenuItem>
        <MenuItem value={DayOfWeek.Sunday}>{t('f-com-sunday')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default WeekDaySelect;
